export default _ => window.location.reload()



// WEBPACK FOOTER //
// ./src/helpers/reloadWindow.js